<template>
  <div>
    <el-form @submit.native.prevent="getData(newBusinessId, newDistrict)">
    <el-row :gutter="20" type="flex" justify="center">
      <el-col class="wrapper">
        <el-select v-model="newDistrict" placeholder="Valitse piiri">
          <el-option
            v-for="district in districts"
            :key="district.value"
            :label="district.label"
            :value="district.value">
          </el-option>
        </el-select>
        <el-input class="business-id" placeholder="Y-tunnus" v-model="newBusinessId"></el-input>
        <el-button :disabled="!formReady" type="primary" native-type="submit">Hae</el-button>
      </el-col>
    </el-row>
    <el-row type="flex" justify="center">
      <div class="error" v-if="error">{{ error.text }}</div>
      <div v-if="!error && offices && offices.length === 0 && contacts && contacts.length === 0 && searchCount > 0">
        Tässä piirissä ei ole yhteyshenkilöitä tai toimipaikkoja
      </div>
      <div v-if="isLoading">Ladataan...</div>
    </el-row>
    </el-form>
  </div>
</template>

<script>
  import { data } from './mixins/getData';

  export default {
    data() {
      return {
        newDistrict: null,
        newBusinessId: null,
        districts: [
          {
            value: 'itä-suomi',
            label: 'Itä-Suomi',
          },
          {
            value: 'lahti-kymi',
            label: 'Lahti-Kymi',
          },
          {
            value: 'lappi',
            label: 'Lappi',
          },
          {
            value: 'lounais-suomi',
            label: 'Lounais-Suomi',
          },
          {
            value: 'pohjanmaa',
            label: 'Pohjanmaa',
          },
          {
            value: 'pohjois-suomi',
            label: 'Pohjois-Suomi',
          },
          {
            value: 'satakunta',
            label: 'Satakunta',
          },
          {
            value: 'sisä-suomi',
            label: 'Sisä-Suomi',
          },
          {
            value: 'uusimaa',
            label: 'Uusimaa',
          },
        ],
      };
    },

    computed: {
      error() {
        return this.$store.getters.error;
      },
      contacts() {
        return this.$store.getters.contactsByDistrict;
      },
      offices() {
        return this.$store.getters.officesByDistrict;
      },
      formReady() {
        return this.newBusinessId && this.newDistrict && this.newBusinessId.length > 0 && this.newDistrict.length > 0;
      },
      isLoading() {
        return this.$store.getters.isLoading;
      },
      searchCount() {
        return this.$store.getters.searchCount;
      }
    },

    mixins: [data],
  };
</script>

<style lang="scss" scoped>
  .wrapper {
    text-align: center;
    display: flex;
    flex-direction: row;
    align-items: baseline;
    justify-content: center;
    > * {
      margin-bottom: 8px;
      margin-right: 8px;
    }
  }

  .error {
    color: red;
  }

  .business-id {
    width: 200px;
  }

  @media (max-width: 480px) {
    .wrapper {
      flex-direction: column;
      align-items: center;
      > * {
        margin-right: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Search.vue?10f8f943